// extracted by mini-css-extract-plugin
export var component = "styles-module--component---9TWY";
export var cycleSlideshow = "styles-module--cycle-slideshow--Vxma-";
export var projectItem = "styles-module--project-item--UimRT";
export var projectItemButtons = "styles-module--project-item-buttons--FJsRR";
export var projectItemContent = "styles-module--project-item-content--a6jAU";
export var projectItemThumb = "styles-module--project-item-thumb--Jt6gS";
export var projectItems = "styles-module--project-items--FSsGg";
export var videoButton = "styles-module--video-button--eFbmc";